var map = {
	"./en/common.json": "1e1c",
	"./en/home.json": "f6f3",
	"./en/navigate.json": "3bfe",
	"./en/poi.json": "1d00",
	"./zh/common.json": "ff36",
	"./zh/home.json": "b3d8",
	"./zh/navigate.json": "80e1",
	"./zh/poi.json": "fd2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b93c";